<i18n>
{
  "fr": {
    "copy": "Copié !"
  }
}
</i18n>

<template>
  <button class="text-copy-button" :disabled="hasCopied" @click="copy">
    <span class="text-copy-button__label">{{ label }}</span>
    <i class="text-copy-button__icon icon icon--copy"></i>
    <span
      :class="[
        'text-copy-button__tooltip',
        { 'text-copy-button__tooltip--active': hasCopied },
      ]"
    >
      {{ $t('copy') }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'TextCopyButton',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hasCopied: false,
    };
  },
  methods: {
    copy() {
      this.hasCopied = true;
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(this.label);
      }

      setTimeout(() => {
        this.hasCopied = false;
      }, 1500);
    },
  },
};
</script>
